import styled from 'styled-components';
import { Body2 } from 'ui/theme';

type Props = {
  metric: {
    label: string;
    SmsSent?: number;
    SmsSegmentsSent?: number;
  };
};

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr ${(props) => `repeat(2, ${props.theme.spacing.utils.pxToRem(160)})`};
  padding: 8px 24px;
`;

const Label = styled(Body2)`
  margin: 0;
`;

const MetricValue = styled(Body2)`
  margin: 0;
  text-align: right;
`;

export const GlobalSmsRow = ({ metric }: Props) => {
  const {
    // SmsSent,
    SmsSegmentsSent,
    label,
  } = metric;
  return (
    <Row>
      <Label>{label}</Label>
      <MetricValue>
        {/*
        SmsSent is not currently being captured for Global SMS -- it may be added in future
        Leaving the MetricValue to retain the spacing.
        {SmsSent || '-'}
      */}
      </MetricValue>
      <MetricValue>{SmsSegmentsSent || '-'}</MetricValue>
    </Row>
  );
};
